import { PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT, PLAYLIST_URL_FRAGMENT } from '../../constants/Navigation.legacy';
export const getPlaylistAssignmentsUrl = (playlistId, portalId) => {
  return portalId ? `${PLAYLIST_ASSIGNMENTS_PORTAL_URL_FRAGMENT.replace(`:playlistId`, playlistId.toString()).replace(`:portalId`, portalId.toString())}` : `${PLAYLIST_URL_FRAGMENT.replace(`:playlistId`, playlistId.toString())}`;
};
export const getTotalProgressFromItemsProgress = itemsProgress => {
  return Math.ceil(itemsProgress.reduce((acc, val) => {
    if (val.status === 'COMPLETED') return acc + 100;
    return acc + val.progressLevel;
  }, 0) / itemsProgress.length) || 0;
};